
import React from "react";
import BookingFlow from "./BookingFlow";

export default function MagicFlow() {
  return <BookingFlow />;
}
